<template>
  <v-container fluid justify-start>

    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="filteredEvents"
      :loading="isLoading"
      :search="search"
      :custom-filter="customFilter"
      :no-data-text="noDataText"
      item-key="id"
      class="elevation-2"
      >

      <v-progress-linear slot="progress" :color="appColor_Progress" indeterminate />

      <template v-slot:top>
        <!-- Header Toolbar -->
        <v-toolbar dense dark flat :color="appColor_Medium">
          
          <app-back-button v-bind:color="appColor_Dark" />

          <v-toolbar-title>Kiosk Events</v-toolbar-title>

        </v-toolbar>

        <!-- Filters -->
        <v-row no-gutters class="mx-3 mt-2">
          <!-- Verbose -->
          <v-col cols="12" md="1">
            <v-checkbox
              v-model="verbose"
              :color="appColor_Selected"
              label="Verbose"
            />
          </v-col>

          <!-- Search -->
          <v-col cols="12" md="11">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              :disabled="isLoading"
              clearable
              class="ml-4"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.username="{ item }">
        <span class="text-left">
          {{ `${item.username} (${item.email})`  }}
        </span>
      </template>

      <template v-slot:item.description="{ item }">
        <span v-if="item.errorMessage === null" class="text-left">
          {{ item.description }}
        </span>

        <span v-else @click="displayError(item)" :style="appStyle_HyperLink">
          {{ getErrorLabel(item) }}
        </span>
      </template>

      <template v-slot:item.createDate="{ item }">
        <span class="text-left"><app-date :date="item.createDate" /></span>
      </template>

    </v-data-table>

  </v-container>
</template>

<script>
import appService from '@/app.service.js'
import { AppColor, AppStyle } from '@/config.js'
import AppDate from '@/components/App/AppDate'
import AppBackButton from '@/components/App/AppBackButton'

export default {
  name: 'UserEvents',
  components: {
    AppDate,
    AppBackButton
  },
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,
      appColor_Dark: AppColor.Dark,
      appColor_Progress: AppColor.Progress,
      appColor_Selected: AppColor.Selected,
      
      // styles
      appStyle_HyperLink: AppStyle.HyperLink,

      isLoading: true,
      search: '',
      verbose: false,

      headers: [
        {
          text: 'Performed By',
          value: 'username',
          align: 'left',
          width: '25%',
          class: 'pr-0'
        },
        {
          text: 'Role',
          value: 'performedByRole',
          align: 'left',
          width: '10%',
          class: 'pr-0'
        },
        {
          text: 'Description',
          value: 'description',
          align: 'left',
          width: '27%',
          class: 'pr-0'
        },
        {
          text: 'Kiosk',
          value: 'targetName',
          align: 'left',
          width: '15%',
          class: 'pr-0'
        },
        {
          text: 'Type',
          value: 'targetContext',
          align: 'left',
          width: '5%',
          class: 'pr-0'
        },
        {
          text: 'Date',
          value: 'createDate',
          align: 'left',
          width: '12%',
          class: 'pr-0'
        }
      ],
      kioskEvents: []
    }
  },
  computed: {
    noDataText () {
      if (this.isLoading) return 'One moment...'

      return this.events.length === 0
        ? 'No kiosk events found'
        : ''
    },
    filteredEvents () {
      if (this.isLoading) return []
      if (this.events === null) return []

      const self = this

      return self.events.filter(e => {
        return (
          self.verbose || (!e.description.startsWith('Attempting to') && !e.description.indexOf('Error') >= 0)
        )
      })
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      appService.getKioskEvents().then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.events = data.events
        }
        self.isLoading = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    getErrorLabel (item) {
      if (item.description.indexOf('invalid data') >= 0) {
        return 'Validation Failed'
      } else if (item.description.indexOf('Error occurred') >= 0) {
        return 'Internal Error'
      }
    },

    displayError (item) {
      var errorSeverity = null

      if (item.description.indexOf('invalid data') >= 0) 
        errorSeverity = 0
      else if (item.description.indexOf('Error occurred') >= 0)
        errorSeverity = 1

      this.handleError({
        errorSeverity: errorSeverity,
        errorMessage: item.errorMessage
      })
    },

    customFilter (value, search, item) {
      const description = item.errorMessage !== null
        ? this.getErrorLabel(item)
        : item.description


      return (
        (value != null &&
          search != null &&
          item.username
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1 ||
          item.performedByRole
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1 ||
          description
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1 ||
          item.targetName
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1 ||
          (item.targetContext ?? '')
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1
      ))
    },

    handleError (result) {
      this.$error.show({
        title:
          result.errorSeverity === 0 ? 'Validation Failed' : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  }
}
</script>
